import { PublicClientApplication, type Configuration, type RedirectRequest } from "@azure/msal-browser";

interface EntraWebConfig {
  clientId: string;
  authority: string;
  knownAuthority: string;
  apiScope: string;
}

export const entraWebConfig = readEntraWebConfig();

export const msalInstance = entraWebConfig
  ? new PublicClientApplication(buildMsalConfig(entraWebConfig))
  : null;

export const loginRequest: RedirectRequest | null = entraWebConfig
  ? {
      scopes: [entraWebConfig.apiScope],
    }
  : null;

function readEntraWebConfig(): EntraWebConfig | null {
  const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;
  const authority = import.meta.env.VITE_ENTRA_AUTHORITY;
  const knownAuthority = import.meta.env.VITE_ENTRA_KNOWN_AUTHORITY;
  const apiScope = import.meta.env.VITE_API_SCOPE;

  if (!clientId && !authority && !knownAuthority && !apiScope) return null;
  if (!clientId || !authority || !knownAuthority || !apiScope) {
    throw new Error(
      "VITE_ENTRA_CLIENT_ID, VITE_ENTRA_AUTHORITY, VITE_ENTRA_KNOWN_AUTHORITY, and VITE_API_SCOPE must be set together."
    );
  }

  return { clientId, authority, knownAuthority, apiScope };
}

function buildMsalConfig(config: EntraWebConfig): Configuration {
  return {
    auth: {
      clientId: config.clientId,
      authority: config.authority,
      knownAuthorities: [config.knownAuthority],
      redirectUri: window.location.origin,
      postLogoutRedirectUri: `${window.location.origin}/signed-out`,
    },
    cache: {
      cacheLocation: "localStorage",
    },
  };
}
